import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import {
  SendPokecoinsInput,
  SendPokecoinsOutput,
  WebAppRoutes,
} from "types/web-app";

export const sendPokecoins = async (
  accessToken: string,
  input: SendPokecoinsInput,
) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.SEND_POKECOINS,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    return (await response.json()) as ServiceResponse<SendPokecoinsOutput>;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
